module.exports = __webpack_public_path__ + "img/top_happybrain.90e6d411.jpg";